import { CommonParagraph } from '@/app/shared/common.StyledComponents';
import styled from '@emotion/styled';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled(CommonParagraph)`
  font-size: 32px;
  padding: 0px 0px 8px 0px;
  font-family: 'Gotham';
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  color: ${({ theme }) => theme.colors.greyscale.gray40};
`;
